import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id", "value", "placeholder"]
const _hoisted_2 = {
  class: "d-flex justify-content-center align-items-center",
  style: {"padding":"16px"}
}
const _hoisted_3 = ["onClick"]

import {
	reactive,
	ref,
	computed,
	watch,
} from "vue"
import ContainerBox from "@/components/LoginRegister/common/ContainerBox/v1/ContainerBox.vue"
import ChevronDownSvg from "@/components/LoginRegister/svg/ChevronDownSvg.vue"
import { onClickOutside } from "@vueuse/core"

type SelectValue = string | number | boolean
type SelectOption = {
	value: SelectValue
	label: string
	[key: string]: any
}
type SelectOptionsList = SelectOption[]

interface Props {
	id?: string
	disabled?: boolean
	options: SelectOptionsList
	selectedOption: SelectOption | null | undefined
	placeholder: string
	border?: string
	borderActive?: string
	boxShadow?: string
	boxShadowActive?: string
	borderBoxShadowDisabled?: boolean
	maxResults?: number
	filterFields: string[]
	containerBorderRadius?: string
}
interface Emits {
	(e: "selectClick", option: SelectOption): void
}

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'Autocomplete',
  props: {
    id: {},
    disabled: { type: Boolean },
    options: {},
    selectedOption: {},
    placeholder: {},
    border: {},
    borderActive: {},
    boxShadow: {},
    boxShadowActive: {},
    borderBoxShadowDisabled: { type: Boolean },
    maxResults: { default: 10 },
    filterFields: {},
    containerBorderRadius: {}
  },
  emits: ["selectClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// emit
const emit = __emit

// refs
const select = ref()
const input = ref()

// state
const state = reactive({
	dropdownOpen: false,
	inputValue: "",
})

// computed
const optionsToShow = computed(() => {
	return filterResults(state.inputValue)
})

// handlers
const displayDropdown = () => {
	if (props.disabled) return
	state.dropdownOpen = true
	state.inputValue = ""
	input.value.focus()
}
const hideDropdown = () => {
	state.dropdownOpen = false
	state.inputValue = props.selectedOption ? props.selectedOption.label : ""
}
const handleSelect = (option: SelectOption) => {
	state.dropdownOpen = false
	if (props.disabled) return
	state.inputValue = option.label
	emit("selectClick", option)
}
const handleInput = (e: any) => {
	state.inputValue = e.target.value
}

const filterResults = (value: string) => {
	if (!value) return props.options.slice(0, props.maxResults)

	const results: SelectOption[] = []
	for (const option of props.options) {
		if (results.length >= props.maxResults) break
		let matchFlag = false

		props.filterFields.forEach((field: string) => {
			const fieldKey = field as keyof SelectOption
			if (!option[fieldKey]) return
			if (
				option[fieldKey]
					.toString()
					.toLowerCase()
					.indexOf(value.toLowerCase()) !== -1
			)
				matchFlag = true
		})

		if (matchFlag) results.push(option)
	}
	return results
}

// click outside
onClickOutside(select, () => {
	if (state.dropdownOpen) hideDropdown()
})

watch(
	() => props.selectedOption,
	() => {
		state.inputValue = props.selectedOption ? props.selectedOption.label : ""
	}
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "select",
    ref: select,
    onClick: _withModifiers(() => {}, ["stop"]),
    class: "select",
    style: {"position":"relative"}
  }, [
    _createVNode(ContainerBox, {
      border: props.border,
      "border-active": props.borderActive,
      "box-shadow": props.borderBoxShadowDisabled ? 'none' : props.boxShadow,
      "box-shadow-active": 
				props.borderBoxShadowDisabled ? 'none' : props.boxShadowActive
			,
      active: state.dropdownOpen,
      style: {"transition":"box-shadow 100ms ease"},
      borderRadius: props.containerBorderRadius
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (state.dropdownOpen ? hideDropdown() : displayDropdown()), ["stop"])),
          role: "button",
          class: _normalizeClass(["main-box d-flex flex-row justify-content-between", props.disabled && 'disabled'])
        }, [
          _createElementVNode("input", {
            id: props.id,
            ref_key: "input",
            ref: input,
            class: "autocomplete-input form-control-plaintext",
            type: "text",
            style: {"padding":"16px 0px 16px 16px"},
            value: state.inputValue,
            placeholder: props.placeholder,
            onClick: _withModifiers(() => {}, ["stop"]),
            onInput: handleInput,
            onFocus: displayDropdown
          }, null, 40, _hoisted_1),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(ChevronDownSvg)
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["border", "border-active", "box-shadow", "box-shadow-active", "active", "borderRadius"]),
    (state.dropdownOpen)
      ? (_openBlock(), _createBlock(ContainerBox, {
          key: 0,
          height: 'initial',
          background: 'white',
          class: "selectDropdown"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsToShow.value, (option, option_i) => {
              return (_openBlock(), _createElementBlock("div", {
                role: "button",
                class: "select-dropdown-option",
                onClick: () => handleSelect(option),
                key: option_i
              }, [
                _renderSlot(_ctx.$slots, "default", { option: option }, () => [
                  _createTextVNode(_toDisplayString(option.label), 1)
                ])
              ], 8, _hoisted_3))
            }), 128))
          ]),
          _: 3
        }))
      : _createCommentVNode("", true)
  ], 512))
}
}

})